import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { History } from 'history';
import { IntlShape } from 'react-intl';

import { CopyLessonModalStore, CREATION_TYPE } from '../typings';

import { showLessonCopiedToClassesToast } from './showLessonCopiedToClassesToast';

const initialState: CopyLessonModalStore = {
    creationType: CREATION_TYPE.COPY_FROM_OWN,
    shouldShowModal: false,
    sourceId: null,
    newName: null,
    copyLessonLoadingStatus: LOADING_STATUSES.UNSENT,
};

// Параметры нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars */
const slice = createSlice({
    name: 'COPY_LESSON_MODAL',
    initialState: initialState,
    reducers: {
        closeModal: () => initialState,

        toggleModal: (state, action: PayloadAction<{ shouldShowModal: boolean }>) => {
            const { shouldShowModal } = action.payload;

            state.shouldShowModal = shouldShowModal;
        },

        copyCLesson: (
            state,
            action: PayloadAction<{
                sourceId: number;
                newName: string;
                history: History;
                intl: IntlShape;
            }>
        ) => {
            const { sourceId, newName } = action.payload;

            state.sourceId = sourceId;
            state.newName = newName;
        },

        copyLessonAsRNO: (
            state,
            action: PayloadAction<{
                sourceId: number;
                newName: string;
                history: History;
                intl: IntlShape;
            }>
        ) => {
            const { sourceId, newName } = action.payload;

            state.sourceId = sourceId;
            state.newName = newName;
            state.creationType = CREATION_TYPE.COPY_AS_RNO;

            state.copyLessonLoadingStatus = LOADING_STATUSES.LOADING;
        },

        copyLessonToTeamsRequest: (
            state,
            action: PayloadAction<{
                teamIds: Array<number>;
                intl: IntlShape;
                history: History;
                creationType?: CREATION_TYPE;
            }>
        ) => {
            // saga

            state.copyLessonLoadingStatus = LOADING_STATUSES.LOADING;
        },

        copyLessonToTeamsSuccess: (state) => {
            state.copyLessonLoadingStatus = LOADING_STATUSES.SUCCESS;
        },

        copyLessonToTeamsError: (state) => {
            state.copyLessonLoadingStatus = LOADING_STATUSES.ERROR;
        },
    },
});
/* eslint-enable @typescript-eslint/no-unused-vars */

export default {
    ...slice.actions,
    showLessonCopiedToClassesToast,
};

export const reducer = slice.reducer;
